// 专项流程

import {
    getXytjList,
    getBbmxList,
    getXymxList,
    getXyfhList,
    getYbsbgList,
    getYbsbgfhList,
    selectZxlc,
    getHldmxList,
    getYbsbgTjList,
    getWdgList
} from "@/api/zxlc";
import { getXmxxList, getDict, getBmxxList } from "@/api/common";
const state = {
    xmxyIndexData: {
    },
    ybsIndexData: {

    },
    xyfhList: {
        list: [],
        total: 0,
    },
    xymxList: {
        list: [],
        total: 0,
    },
    xytjList: {
        list: [],
        total: 0,
    },
    bbmxList: {
        list: [],
        total: 0
    },

    ybsbgList: { //一把手变更列表
        list: [],
        total: 0
    },
    hldbgList: { //行领导变更列表
        list: [],
        total: 0
    },
    ybsbgfhList: { //一把手变更发函明细列表
        list: [],
        total: 0
    },
    ybsbgtjList: { //一把手变更统计列表
        list: [],
        total: 0
    },
    wdgList: { //一把手未到岗列表
        list: [],
        total: 0
    },
    bmList: [],
    xmList: [],
    htztList: [],
    xyjdList: [],
    fhjgList: [],
    xymsList: [],//续约模式
    hzqxList: [],//合作期限
    xyjgList: [], //续约结果
    gxrjsList: [],//干系人角色
    khtdList: [],//是否认可天维
    zwgxList: [], // 是否与天维合作过
    xmztList: [], // 项目状态列表
    xgdjList: [] //效果等级列表

};
const mutations = {
    fetchXmxyIndexData(state, res) {
        if (res.code == 0) {
            state.xmxyIndexData = res.data;
        }
    },
    fetchYbsIndexData(state, res) {
        if (res.code == 0) {
            state.ybsIndexData = res.data;
        }
    },
    fetchXyfhList(state, res) {
        if (res.code == 0) {
            state.xyfhList.list = res.data;
            state.xyfhList.total = res.count;
        }
    },
    fetchXymxList(state, res) {
        if (res.code == 0) {
            let tempList = res.data;
            let tempObj = {}
            for (let i in tempList) {
                tempObj = {
                    xmxgzp: null,
                    cjdghqd: null,
                    cjdylb: null,
                    ybsrzpg: null,
                    khbf: null,
                    clyt: null,
                    bgbx: null,
                    xyhb: null,
                    swgtjd: null,
                    htqdjd: null,
                }
            }
            state.xymxList.list = res.data;
            state.xymxList.total = res.count;
        }
    },
    fetchXytjList(state, res) {
        if (res.code == 0) {
            state.xytjList.list = res.data;
            state.xytjList.total = res.count;
        }
    },
    fetchBbmxList(state, res) {
        if (res.code == 0) {
            state.bbmxList.list = res.data;
            state.bbmxList.total = res.count;
        }
    },
    fetchYbsbgList(state, res) {
        let arr = []
        if (res.code == 0) {
            for (let i in res.data) {
                if (res.data[i].cgws) {
                    res.data[i].cgwsArr = res.data[i].cgws.split(',');
                    res.data[i].cgwsObj = []
                    for (let j in res.data[i].cgwsArr) {
                        const str = res.data[i].cgwsArr[j];
                        let obj = {}
                        obj = {
                            point: str.match(new RegExp('节点：' + "(.*)" + '文件名称：'))[1],
                            fileName: str.match(new RegExp('文件名称：' + "(.*)" + '上传时间：'))[1],
                            uploadTime: str.split('上传时间：')[1]
                        }
                        res.data[i].cgwsObj.push(obj)
                    }
                }
            }
            state.ybsbgList.list = res.data;
            state.ybsbgList.total = res.count;
        }
    },
    fetchYbsbgfhList(state, res) {
        if (res.code == 0) {
            state.ybsbgfhList.list = res.data;
            state.ybsbgfhList.total = res.count;
        }
    },

    fetchHldbgfhList(state, res) {
        if (res.code == 0) {
            state.hldbgList.list = res.data;
            state.hldbgList.total = res.count;
        }
    },

    fetchYbsbgtjList(state, res) {
        if (res.code == 0) {
            state.ybsbgtjList.list = res.data;
            state.ybsbgtjList.total = res.count;
        }
    },
    fetchWdgList(state, res) {
        if (res.code == 0) {
            state.wdgList.list = res.data;
            state.wdgList.total = res.count;
        }
    },

    //************************ */
    fetchBmList(state, res) {
        if (res.code == 0) {
            state.bmList = res.data;
        }
    },
    fetchHtztList(state, res) {
        if (res.code == 0) {
            state.htztList = res.data;
        }
    },
    fetchXmztList(state, res) {
        if (res.code == 0) {
            state.xmztList = res.data;
        }
    },


    fetchXyjdList(state, res) {
        if (res.code == 0) {
            state.xyjdList = res.data;
        }
    },
    fetchFhjgList(state, res) {
        if (res.code == 0) {
            state.fhjgList = res.data;
        }
    },
    fetchXmxxList(state, res) {
        if (res.code == 0) {
            state.xmList = res.data;
        }
    },
    fetchXymsList(state, res) {
        if (res.code == 0) {
            state.xymsList = res.data;
        }
    },
    fetchHzqxList(state, res) {
        if (res.code == 0) {
            state.hzqxList = res.data;
        }
    },
    fetchXyjgList(state, res) {
        if (res.code == 0) {
            state.xyjgList = res.data;
        }
    },
    fetchGxrjsList(state, res) {
        if (res.code == 0) {
            state.gxrjsList = res.data;
        }
    },
    fetchKhtdList(state, res) {
        if (res.code == 0) {
            const temp = [];
            for (let i of res.data) {
                if (i.dictValue == 7 || i.dictValue == 6) {
                    temp.push(i)
                }
            }
            state.khtdList = temp;
        }
    },
    fetchZwgxList(state, res) {
        if (res.code == 0) {
            const temp = [];
            for (let i of res.data) {
                if (i.dictValue == 5 || i.dictValue == 6) {
                    temp.push(i)
                }
            }
            state.zwgxList = temp;
        }
    },
    fetchXgdjList(state, res) {
        if (res.code == 0) {
            state.xgdjList = res.data;
        }
    },
};
const actions = {

    /**
     * 首页 项目续约数据
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchXmxyIndexDataAction(context, payload) {
        return new Promise((resolve, reject) => {
            selectZxlc({ ...payload, type: '1' }).then((res) => {
                context.commit("fetchXmxyIndexData", res);
                resolve(res);
            })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    /**
     * 首页 一把手变更数据
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchYbsIndexDataAction(context, payload) {
        return new Promise((resolve, reject) => {
            selectZxlc({ ...payload, type: '2' }).then((res) => {
                context.commit("fetchYbsIndexData", res);
                resolve(res);
            })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    /**
     * 续约发函列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchXyfhListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getXyfhList(payload).then((res) => {
                context.commit("fetchXyfhList", res);
                resolve(res);
            })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    /**
     * 项目续约明细列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchXymxListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getXymxList(payload).then((res) => {
                context.commit("fetchXymxList", res);
                resolve(res);
            })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    /**
     * 获取项目续约统计列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchXytjListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getXytjList(payload).then((res) => {
                context.commit("fetchXytjList", res);
                resolve(res);
            })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    /**
     * 获取报表钻取明细列表（续约）
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchBbmxListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getBbmxList(payload)
                .then((res) => {
                    context.commit("fetchBbmxList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    /**
     * 项目一把手变更明细列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchYbsbgListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getYbsbgList(payload)
                .then((res) => {
                    context.commit("fetchYbsbgList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    /**
     * 项目一把手变更发函明细列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchYbsbgfhListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getYbsbgfhList(payload)
                .then((res) => {
                    context.commit("fetchYbsbgfhList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    /**
     * 获取行领导变更明细列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchHldbgfhListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getHldmxList(payload)
                .then((res) => {
                    context.commit("fetchHldbgfhList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    /**
     * 一把手变更统计列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchYbsbgtjListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getYbsbgTjList(payload)
                .then((res) => {
                    context.commit("fetchYbsbgtjList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    /***
     * 项目一把手变更未到岗明细
     */
    fetchWdgListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getWdgList(payload)
                .then((res) => {
                    context.commit("fetchWdgList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    fetchXmxxListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getXmxxList(payload)
                .then((res) => {
                    context.commit("fetchXmxxList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },



    /**
     * 获取部门列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchBmListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getBmxxList(payload)
                .then((res) => {
                    context.commit("fetchBmList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    /**
     * 获取合同状态
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchHtztListAction(context, payload) {
        return new Promise((resolve, reject) => {
            const { dictType, type, } = payload;
            getDict(dictType, type)
                .then((res) => {
                    context.commit("fetchHtztList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    /**
     * 获取项目状态
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchXmztListAction(context, payload) {
        return new Promise((resolve, reject) => {
            const { dictType, type, } = payload;
            getDict(dictType, type)
                .then((res) => {
                    context.commit("fetchXmztList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    /**
     * 续约阶段列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchXyjdListAction(context, payload) {
        return new Promise((resolve, reject) => {
            const { dictType, type, } = payload;
            getDict(dictType, type)
                .then((res) => {
                    context.commit("fetchXyjdList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },


    /**
     * 发函结果列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchFhjgListAction(context, payload) {
        return new Promise((resolve, reject) => {
            const { dictType, type, } = payload;
            getDict(dictType, type)
                .then((res) => {
                    context.commit("fetchFhjgList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },



    /**
     * 续约模式
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchXymsListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getDict('pmp_xmxy_xyms')
                .then((res) => {
                    context.commit("fetchXymsList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    /**
     * 合作期限
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchHzqxListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getDict('pmp_xmxy_hzqx')
                .then((res) => {
                    context.commit("fetchHzqxList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    /**
     * 续约结果
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchXyjgListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getDict('pmp_xmxy_xyjg')
                .then((res) => {
                    context.commit("fetchXyjgList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    /**
     * 干系人角色列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchGxrjsListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getDict('xmgl_gxr_jslx')
                .then((res) => {
                    context.commit("fetchGxrjsList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    /**
     * 是否认可天维
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchKhtdListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getDict('khtd', 2)
                .then((res) => {
                    context.commit("fetchKhtdList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    /**
     * 是否与天维合作过的列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchZwgxListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getDict('zwgx', 2)
                .then((res) => {
                    context.commit("fetchZwgxList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    /**
     * 效果等级列表
     * @param {*} context 
     * @param {*} payload 
     * @returns 
     */
    fetchXgdjListAction(context, payload) {
        return new Promise((resolve, reject) => {

            getDict('pmp_task_xgdj')
                .then((res) => {
                    context.commit("fetchXgdjList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
